
import {
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGIN,
    TOKEN_LOGIN, SET_SITE
} from '../types/login';

import {storageAvailable} from "../Helpers";

const initialState = {
    token: null,
    user: null,
    person: null,
    sites: [],
    loggingIn: false,
    loggedIn: false,
    site: null,
};

const setToken = (token) => {

    if (storageAvailable('localStorage')) {
        if(token){
            localStorage.setItem('token', token);
            localStorage.setItem('token_date', new Date().toUTCString())
        }else {
            localStorage.removeItem('token');
            localStorage.removeItem('token_date')
        }

    }

    return token;
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                loggingIn: true,
                loggedIn: false
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                token: setToken(action.response.data.token),
                user: action.response.data.user,
                person: action.response.data.person,
                sites : action.response.data.sites,
                loggingIn: false,
                loggedIn: true

            };
        case TOKEN_LOGIN:
            return {
                ...state,
                token: action.response.data.token,
                user: action.response.data.user,
                person: action.response.data.person,
                sites : action.response.data.sites,
                loggingIn: false,
                loggedIn: true

            };
        case LOGIN_FAIL:
            return {
                ...state,
                loggingIn: false,
                loggedIn: false,
                token: setToken(null),
                user: null,
                person: null,
                sites: []
            };
        case SET_SITE:
            return {
                ...state,
                site: action.data.site
            };

        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/login.js